import { toPng } from "html-to-image";
import {
  applyChronosExportForeignObjectTextFix,
  computeChronosExportPixelRatio,
} from "./chronosExportTextFix";

function isLikelyCanvasHardwareError(e) {
  const msg = String(e?.message ?? e ?? "");
  return (
    msg.includes("error state") ||
    msg.includes("InvalidStateError") ||
    /canvas/i.test(msg)
  );
}

/**
 * Rasterizes the Chronos card with html-to-image. Retries with library downscaling if the
 * browser rejects an oversized canvas (drawImage / "error state").
 */
export async function captureChronosCardToPng(
  el,
  { backgroundColor = "#1e1e24", skipFonts = true } = {}
) {
  if (!el?.scrollWidth) {
    throw new Error("Élément introuvable.");
  }
  const w = el.scrollWidth;
  const h = el.scrollHeight;
  const prOptimal = computeChronosExportPixelRatio(w, h);
  const restoreFo = applyChronosExportForeignObjectTextFix(el);
  const base = {
    cacheBust: true,
    backgroundColor,
    width: w,
    height: h,
    skipFonts,
  };
  try {
    try {
      return await toPng(el, {
        ...base,
        pixelRatio: prOptimal,
        skipAutoScale: true,
      });
    } catch (e) {
      if (!isLikelyCanvasHardwareError(e)) {
        throw e;
      }
      const prMid = Math.max(
        0.5,
        Math.round(prOptimal * 0.65 * 1000) / 1000
      );
      if (Math.abs(prMid - prOptimal) > 0.03) {
        try {
          return await toPng(el, {
            ...base,
            pixelRatio: prMid,
            skipAutoScale: true,
          });
        } catch (e2) {
          if (!isLikelyCanvasHardwareError(e2)) {
            throw e2;
          }
        }
      }
      return await toPng(el, {
        ...base,
        pixelRatio: 1,
        skipAutoScale: false,
      });
    }
  } finally {
    restoreFo();
  }
}
